import { render, staticRenderFns } from "./NewCheck.vue?vue&type=template&id=0451389a&scoped=true&"
import script from "./NewCheck.vue?vue&type=script&lang=js&"
export * from "./NewCheck.vue?vue&type=script&lang=js&"
import style0 from "./NewCheck.vue?vue&type=style&index=0&id=0451389a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0451389a",
  null
  
)

export default component.exports